import _mapValues from 'lodash/mapValues'
import _uniqueId from 'lodash/uniqueId'
import keyMirror from 'keymirror'

export const constants = _mapValues(
  keyMirror({
    CREATE_ORG_STARTED: null,
    CREATE_ORG_FAILED: null,

    FETCH_ORG_STARTED: null,
    FETCH_ORG_FAILED: null,

    UPDATE_ORG_STARTED: null,
    UPDATE_ORG_FAILED: null,

    RECEIVE_ORG: null,

    CHECK_ORG_HANDLE_EXISTENCE_STARTED: null,
    CHECK_ORG_HANDLE_EXISTENCE_FAILED: null,
    RECEIVE_ORG_HANDLE_EXISTENCE: null,

    SET_ORG_HANDLE_UI: null,

    RECEIVE_USER_SCOPES: null,

    RECEIVE_ORG_PROPERTIES: null,

    RECEIVE_ORG_CUTOVER: null,

    SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_STARTED: null,
    SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_COMPLETED: null,
    SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_FAILED: null,

    SEND_INVITATIONS_VIA_EMAIL_STARTED: null,
    SEND_INVITATIONS_VIA_EMAIL_COMPLETED: null,
    SEND_INVITATIONS_VIA_EMAIL_FAILED: null,

    FETCH_END_USER_COUNT: null,
    FETCH_END_USER_COUNT_PENDING: null,
    FETCH_END_USER_COUNT_SUCCESS: null,
    FETCH_END_USER_COUNT_FAILED: null,

    SEND_INVITATIONS_VIA_SLACK_STARTED: null,
    SEND_INVITATIONS_VIA_SLACK_COMPLETED: null,
    SEND_INVITATIONS_VIA_SLACK_FAILED: null,

    TOGGLE_CHILLBOT: null,
    TOGGLE_CHILLBOT_COMPLETED: null,
    TOGGLE_CHILLBOT_FAILED: null,

    PATCH_ORG_PROPERTIES: null,
    PATCH_ORG_PROPERTIES_PENDING: null,
    PATCH_ORG_PROPERTIES_SUCCESS: null,
    PATCH_ORG_PROPERTIES_FAILURE: null,

    HAS_LIMITED_CONTACT_MKT_EMAIL: null,
    HAS_LIMITED_CONTACT_MKT_EMAIL_PENDING: null,
    HAS_LIMITED_CONTACT_MKT_EMAIL_SUCCESS: null,
    HAS_LIMITED_CONTACT_MKT_EMAIL_FAILED: null
  }),
  _uniqueId
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/constants.js